import React, { useEffect, useState } from 'react'

import {
    Box,
    Button,
    Typography,
    Container,
    Grid,
    TextField,
    styled,
    Card,
    Tab,
    FormControl,
    FormGroup,
    FormControlLabel,
    IconButton,
    Divider,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';

import {
    TabContext,
    TabList,
    TabPanel
} from "@mui/lab";

import { useFormik } from 'formik';

import CommonBreadcumbs from '../../common/CommonBreadcumbs'
import CommonSectionHeader from '../../common/CommonSectionHeader';

import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useAuthAccess } from '../../../hooks/useAuthAccess';
// import { routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useTranslations } from "../../../hooks/useTranslations";
import { useAppContextFeatures } from '../../../context/AppContext';

import ISMSSetting from "./section/ISMSSetting"
import DefaultSetting from "./section/DefaultSetting"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const RenderTabForm = ({
    handleClick,
    clicked,
}) => {
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={clicked}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleClick} aria-label="lab API tabs example">
                        <Tab label="Default" value="defaultSetting" />
                        <Tab label="iSMS" value="iSmsSetting" />
                    </TabList>
                </Box>
                <TabPanel value="defaultSetting">
                    <DefaultSetting />
                </TabPanel>
                <TabPanel value="iSmsSetting">
                    <ISMSSetting />
                </TabPanel>
            </TabContext>
        </Box>
    )
}

export default function SmsSetting({
    routeType
}) {

    const { t } = useTranslations({ ns: ["_@setting", "common"] })
    const { authData } = useAuthAccess();

    const { getHtmlHead } = useSystemHead(routeType)

    const [clicked, setClicked] = useState('defaultSetting');

    const handleClick = (event, newValue) => {
        setClicked(newValue);
    };

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: "SMS" })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={'SMS'}
                breadcrumbs={[
                    {
                        displayText: 'SMS',
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            <RenderTabForm
                handleClick={handleClick}
                clicked={clicked}
            />


        </Box>
    )
}
